import { render, staticRenderFns } from "./GalleryPaginationApp.vue?vue&type=template&id=4a4fefb4&"
import script from "./GalleryPaginationApp.vue?vue&type=script&lang=js&"
export * from "./GalleryPaginationApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports